import {useLayoutEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

import {openDigitalCardAtExternal, replaceDigitalCard} from '@zzng/common/scheme/digitalcard';
import {isKakaoTalk} from '@zzng/common/utils/agent';
import {goKakaotalkAppStore} from '@zzng/common/utils/scheme';

import PageLayout from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

const MobileGuidePage = () => {
  const {trackPage} = useTiara({pageName: TIARA_PAGE_NAME.ERROR});
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl') ?? `${location.origin}/home`;

  useLayoutEffect(() => {
    trackPage({action: TIARA_ACTION.EXTERNAL_BROWSER_ERROR});

    if (!isKakaoTalk) {
      openDigitalCardAtExternal(redirectUrl);
    }
  }, []);

  const onClickOpenKakaoTalk = () => {
    replaceDigitalCard(redirectUrl);
  };

  const onClickInstallKakaoTalk = () => {
    goKakaotalkAppStore();
  };

  return (
    <PageLayout tiara={false} className="container-bridge" articleClassName="content-full">
      <div className="inner_g">
        <div className="group_empty type2">
          <strong className="tit_g">
            <span className="item_txt" role="text">
              <span className="txt_tit">디지털카드 서비스로 연결됩니다</span>
            </span>
          </strong>
          <p className="txt_g">
            카카오톡이 설치되어 있지 않거나 <br />
            최신 버전이 아닌 경우 연결이 되지 않습니다.
          </p>
          <button
            type="button"
            className="btn btn_yellow type2"
            onClick={onClickOpenKakaoTalk}
            data-tiara-action-name={TIARA_ACTION.EXTERNAL_BROWSER_OPEN_KAKAOTALK_CLICK}
          >
            카카오톡으로 열기
          </button>
          <button
            type="button"
            className="btn btn_gray type2"
            onClick={onClickInstallKakaoTalk}
            data-tiara-action-name={TIARA_ACTION.EXTERNAL_BROWSER_INSTALL_KAKAOTALK_CLICK}
          >
            카카오톡 설치하기
          </button>
        </div>
      </div>
    </PageLayout>
  );
};

export default MobileGuidePage;
